import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "../lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 bg-cream/70 backdrop-blur-xl border-b border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-3 group"
        >
          <div className="h-16 sm:h-[4.5rem] w-auto flex items-center pr-1 sm:pr-2">
            <img
              src={LOGO_URL}
              alt="Gralon"
              className="h-full w-auto object-contain"
            />
          </div>
          <div className="flex items-center gap-3 sm:gap-4 pl-3 sm:pl-4 border-l border-forest/15">
            <div className="flex flex-col">
              <div className="font-serif text-[1.1rem] sm:text-[1.4rem] tracking-[0.4em] uppercase text-forest-dark font-light leading-none">
                Gralon
              </div>
              <div className="text-[8px] sm:text-[10px] tracking-[0.5em] uppercase text-gold font-semibold mt-1 sm:mt-1.5">
                Global
              </div>
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-300 hover:text-forest-dark ${
                  isActive ? "text-forest-dark" : "text-ink/80"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="nav-inquire-cta"
          className="hidden md:inline-flex items-center px-5 py-2.5 bg-forest text-cream text-sm tracking-wide hover:bg-forest-dark transition-colors duration-300"
        >
          Inquire Now
        </Link>

        <button
          className="md:hidden text-forest-dark"
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-line bg-cream" data-testid="nav-mobile-panel">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base ${isActive ? "text-forest-dark" : "text-ink/80"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-inquire-cta"
              className="mt-2 inline-flex justify-center items-center px-5 py-3 bg-forest text-cream text-sm tracking-wide"
            >
              Inquire Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
